import TreatmentPlanItem from 'components/TreatmentPlan/Item';
import ChargeItem from 'components/Billing/Charges/Item';
import { PortalSpinner } from 'components/PortalSpinner';
import InfiniteScroll from 'react-infinite-scroll-component'

const List = ({ billingData, loadMore, pageEnd }) => {

  if (!billingData) return <PortalSpinner />;
  if (billingData.length === 0) return <div className="py-16 text-center text-sm text-secondary-400">No activity found.</div>

  return (
    <div className="space-y-3">
      <InfiniteScroll
        dataLength={billingData.length}
        next={loadMore}
        hasMore={!pageEnd}
        loader={<div className="col-span-full flex justify-center py-3"><PortalSpinner /></div>}
        className="grid grid-cols-1 gap-4"
      >
        {billingData.map((item) => {
          let { resource_type, resource, amount } = item.attributes || {}

          return resource_type === 'TreatmentPlan'
            ? <TreatmentPlanItem key={item.id} data={resource?.data} amount={amount} />
            : <ChargeItem key={item.id} data={item} />
        })}
      </InfiniteScroll>
    </div>
  );
};

export default List;
